export default __webpack_public_path__ + "static/media/master_configuration.dbbb17f0.svg";